// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "hash": "1020009",
    "fullHash": "1020009ef2908429f388d5163e4ad3a967ab01cd",
    "branch": "HEAD",
    "tag": "R-25-2.3.3"
};
/* tslint:enable */
